import type { RootState } from "@/lib/types/state";

/**
 * Selects whether this browser has opted in to the cookie-auth pilot.
 * Value is read once at boot from localStorage (see
 * src/redux/actions/cookieAuthPilot.ts) — this selector reads the Redux copy,
 * not localStorage, so it's safe to call per-request.
 *
 * @param state - The root Redux state
 * @returns true if this browser has opted in to the cookie-auth pilot
 */
export const selectIsOptedIntoCookieAuth = (state: RootState): boolean => {
  return state?.cookieAuthPilot?.isOptedIn ?? false;
};
